import { FC, memo } from 'react'
import { Text } from 'yolda-web-ui'
import Icon from '../Icon'
import { Label } from './VehicleLabel.style'
import { getFtlIcon } from '../../../utils/helpers'
import { variant } from 'styled-system'

interface VehicleLabelProps {
  number?: boolean
  text?: string
  type: string
  variant?: 'default' | 'alternative' | 'light'
}

const VehicleLabel: FC<VehicleLabelProps> = ({ text, type, variant }) => {
  return (
    <Label variant={variant}>
      <div>
        <img src={getFtlIcon(type)} />
      </div>
      <Text>{text}</Text>
    </Label>
  )
}

const areEqual = (prev: VehicleLabelProps, next: VehicleLabelProps) => {
  return JSON.stringify(prev) === JSON.stringify(next)
}

export default memo(VehicleLabel, areEqual)
